import React from 'react';
import { Box, VStack, Heading, Text, Button, Icon } from '@chakra-ui/react';
import { FaCheckCircle } from 'react-icons/fa';

const AdminMobileSuccessPage = () => {
  return (
    <Box
      minH="100vh"
      width="100%"
      bg="linear-gradient(180deg, rgba(0,0,0,0.95) 0%, rgba(26,32,44,0.95) 100%)"
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      padding={8}
    >
      <Box 
        width="100%" 
        maxWidth="400px" 
        bg="gray.900" 
        p={8} 
        borderRadius="xl" 
        boxShadow="0 4px 30px rgba(0, 0, 0, 0.4)"
        border="1px solid"
        borderColor="green.500"
      >
        <VStack spacing={6} align="center">
          <Icon as={FaCheckCircle} color="green.400" boxSize={16} />
          
          <Heading 
            color="green.400" 
            textAlign="center" 
            size="lg"
          >
            Login Realizado com Sucesso!
          </Heading>
          
          <Text color="gray.300" textAlign="center">
            Você foi autenticado no totem como administrador.
          </Text>
          
          <Text color="gray.300" textAlign="center">
            Você pode fechar esta janela e voltar ao totem para acessar as funcionalidades administrativas.
          </Text>
          
          <Button
            colorScheme="green"
            size="lg"
            onClick={() => window.close()}
            width="100%"
          >
            Fechar
          </Button>
        </VStack>
      </Box>
    </Box>
  );
};

export default AdminMobileSuccessPage;
